import { render, staticRenderFns } from "./FilesSidebarTab.vue?vue&type=template&id=e4ce9078&scoped=true&"
import script from "./FilesSidebarTab.vue?vue&type=script&lang=js&"
export * from "./FilesSidebarTab.vue?vue&type=script&lang=js&"
import style0 from "./FilesSidebarTab.vue?vue&type=style&index=0&id=e4ce9078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ce9078",
  null
  
)

export default component.exports